import {Context, createContext} from 'solid-js'
import { ReminderProviderBehavior } from './ReminderProvider'

export const ReminderContext: Context<ReminderProviderBehavior> = createContext({
    show: () => undefined,
    isReminderShow: false,
    shownReminders: [],
    focusedReminderId: [],
    setshowReminderPinPopUp: () => undefined,
    showReminderPinPopUp: () => undefined
})
